var $ = require("jquery");
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* ====================== SERVICES / TEAM SLIDER ======================  */
['.links-slider', '.team-slider', '.single-post__related'].forEach(function(selector) {
    var $sliderContainer = $(selector);
    if (!$sliderContainer.length) return;

    var $sliderElement = $sliderContainer.find('.swiper');

    new Swiper($sliderElement[0], {
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        threshold: 1,
        speed: 1000,
        navigation: {
            nextEl: $sliderContainer.find('.swiper-button-next')[0],
            prevEl: $sliderContainer.find('.swiper-button-prev')[0],
        },
        breakpoints: {
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1025: {
              spaceBetween: 30,
            },
            481: {
              slidesPerView: 'auto',
              freeMode: true,
            }
        },
        on: {
            touchStart: () => {
                $sliderElement.addClass('grabbing');
            },
            touchEnd: () => {
                $sliderElement.removeClass('grabbing');
            }
        }
    });
});


function initCustomSwiper(selector, customOptions = {}) {
  const container = document.querySelector(selector);
  if (!container) {
    return;
  }

  const defaultOptions = {
    slidesPerView: 3,
    spaceBetween: 15,
    centeredSlides: true,
    slidesPerGroup: 1,
    speed: 600,
    simulateTouch: false,
    allowTouchMove: false,
    breakpoints: {
      768: {
        spaceBetween: 32,
      }
    },
    on: {
      slideChange: function () {
        const offset = calculateOffset(this.activeIndex, this.slides.length);
        const wrapper = container.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.style.setProperty('--image-carousel-offset', `${offset}%`);
        }
      }
    }
  };

  const swiper = new Swiper(container, {
    ...defaultOptions,
    ...customOptions,
    breakpoints: {
      ...defaultOptions.breakpoints,
      ...customOptions.breakpoints
    }
  });

  let startX = null;
  let isDragging = false;

  // Track drag start
  const onStart = (e) => {
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    isDragging = false;
  };

  // Track drag end & decide if drag or click
  const onEnd = (e) => {
    if (startX === null) return;
    const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const diff = endX - startX;
    if (Math.abs(diff) > 5) {
      // Considered drag
      isDragging = true;
      if (diff > 30) {
        swiper.slidePrev();
      } else if (diff < -30) {
        swiper.slideNext();
      }
    } else {
      // Not drag, could be a tap/click - do nothing here, handled by slide click
      swiper.slideTo(swiper.activeIndex);
    }
    startX = null;
  };

  container.addEventListener('touchstart', onStart);
  container.addEventListener('touchend', onEnd);
  container.addEventListener('mousedown', onStart);
  container.addEventListener('mouseup', onEnd);

  // Add click listener to slides, but only fire if no drag happened
  swiper.slides.forEach((slide, index) => {
    slide.style.cursor = 'pointer';
    slide.addEventListener('click', (e) => {
      // Only trigger if not dragging
      if (!isDragging && swiper.activeIndex !== index) {
        swiper.slideTo(index);
      }
    });
  });

  return swiper;
}



// Initialize swipers
const gallerySwiper = initCustomSwiper('.gallery__slider');
const imageTextSwiper = initCustomSwiper('.image-text-slider__slider', {
  slidesPerView: 1.1,
  simulateTouch: true,
  allowTouchMove: true,
  breakpoints: {
    768: {
      spaceBetween: 32,
      slidesPerView: 1.1,
    },
    1025: {
      spaceBetween: 32,
      slidesPerView: 3,
      simulateTouch: false,
      allowTouchMove: false,
    }
  }
});

function calculateOffset(activeIndex, totalSlides) {
  let offset = 0;
  const isMobile = window.matchMedia('(max-width: 1024px)').matches;
  const multiplier = isMobile ? -15 : -11;

  if (totalSlides > 3 && activeIndex > 1) {
    offset = multiplier * (activeIndex - 1);
    if (activeIndex === totalSlides - 1) {
      offset = multiplier * (activeIndex - 2);
    }
  }

  return offset;
}

var quoteSlider = new Swiper('.quote__slider', {
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    effect: "fade",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.quote .swiper-pagination',
        clickable: true,
    },
});

// Add a 1-second delay before autoplay starts
setTimeout(() => {
    quoteSlider.autoplay.start();
}, 1000);
